export function isIsoDate(value?: string): boolean {
  return !value || /^\d{4}-\d{2}-\d{2}$/.test(value);
}

export function isIsoTimestamp(value?: string): boolean {
  return Boolean(value && !Number.isNaN(Date.parse(value)) && value.includes('T'));
}

export function isCurrency(value?: string): boolean {
  return !value || /^[A-Z]{3}$/.test(value);
}

export function required(value: unknown): boolean {
  return value !== undefined && value !== null && String(value).trim() !== '';
}
